module.exports = __webpack_public_path__ + "media/home1-right.13b99004.mp4";